import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('InvBuyerRelationFilter', InvBuyerRelationFilterData);

    function InvBuyerRelationFilterData() {
        InvBuyerRelationFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
        };

        function InvBuyerRelationFilter(invBuyerRelationFilterData) {
            if (!invBuyerRelationFilterData) {
                this.buildEmpty();
            } else {
                this.build(invBuyerRelationFilterData);
            }
        }

        return InvBuyerRelationFilter;

        function buildEmpty() {
            this.seller = null;
            this.principal = null;
            this.country = null;
            this.enabledService = ['INVOICE','ORDER','DOCUMENTATION_SPACE'];
            this.onlyValidated = null;
            this.onlyAccepted = null;
        }

        function build(invBuyerRelationFilter) {
            this.seller = invBuyerRelationFilter.seller || null;
            this.principal = invBuyerRelationFilter.principal || null;
            this.country = invBuyerRelationFilter.country || null;
            this.enabledService = invBuyerRelationFilter.enabledService || null;
            this.onlyValidated = invBuyerRelationFilter.onlyValidated || null;
            this.onlyAccepted = invBuyerRelationFilter.onlyAccepted || null;
        }

        function preparBeforeSearch() {
            var clone = new InvBuyerRelationFilter(this);
            clone.principalId = this.principal ? this.principal.id : null;
            clone.sellerId = this.seller ? this.seller.id : null;
            clone.countryCode = this.country ? this.country.code : null;
            if (clone.enabledService.includes('INVOICE')) {
                clone.serviceInvoiceEnable = true;
            }
            if (clone.enabledService.includes('ORDER')) {
                clone.serviceOrderEnabled = true;
            }
            if (clone.enabledService.includes('DOCUMENTATION_SPACE')) {
                clone.serviceGEDEnabled = true;
            }

            return clone;
        }
    }
})();
